<div id="authenticator">

    

    <mat-card id="authenticator-content">
        <!-- Bouton Play/Pause -->
        
        <div class="box1" *ngIf="!isRegisterState2()">
            
       <!-- <div class="audio-container">
                <button class="play-pause-button" (click)="toggleAudio()">
                  <mat-icon>{{ isPlaying ? 'pause' : 'play_arrow' }}</mat-icon>
                </button>
                <audio #audioPlayer autoplay= "true" src="../../../assets/audio/02_Bambara_Connecter_Creer_Oublie.m4a"></audio>
              
            
              </div>   --> 
            <img src="../../../assets/images/Lenali_logo_Full.png" alt=""  class="lenali-logo">
            <h4 style="font-weight: bold; color: #08a8ff;">Numéro virtuel</h4>
        </div>
        <mat-card-header>
            <mat-card-title>{{getStateText()}}</mat-card-title>
        </mat-card-header>
        <div *ngIf="isLoginState()">
            <input #loginEmail placeholder="Entre votre numéro 10 xxxx xxxx" required/>
            <input #loginPassword placeholder="Mot de passe" type="password" required>
            <button 
                (click)="login(loginEmail, loginPassword)"
                class="btn-send">Se connecter
            </button>
                
        </div>
        <div *ngIf="isRegisterState()">
            
            <input #registerFirstname placeholder="Prénom">
            <input #registerLastname placeholder="Nom">
            <button 
                (click)="onRegisterClick(
                    registerFirstname,
                    registerLastname
                )"
            class="btn-send">Continuer</button>
            
            
        </div>

        <div *ngIf="isRegisterState2()">
            <div class="virtual-number-container">
                <p class="virtual-number-label">Votre numéro privé</p>
                <div class="virtual-number">{{formatZangiNumber()}}</div>
                <p class="virtual-number-info">⚠️ Conservez précieusement ce numéro, il vous servira d'identifiant de connexion. </p>
            </div>
            <p class="password-label">Définir le mot de passe</p>

            <input #registerPassword placeholder="Mot de passe" type="password" required>
            <input #registerConfirmPassword placeholder="Confirmer mot de passe" type="password" required>
            <button 
                (click)="onRegisterClick2(
                    registerPassword,
                    registerConfirmPassword
                )"
            class="btn-send">Continuer</button>
        </div>
       
        <mat-card-actions align="end" *ngIf="!isRegisterState2()">
            <button mat-flat-button
            (click)="onCreateAccountClick()" style="font-size: 0.75rem; color: green;">Créer un compte</button>
            <button mat-flat-button
            (click)="onLoginClick()" style="font-size: 0.75rem;">Se connecter</button>
        </mat-card-actions>
    </mat-card>
</div>